/**
 * Created by DSadler on 02/05/2017.
 */

/**
 * Returns all images saved in the current editor state
 * @param state
 * @returns {Array}
 */
export const getImages = (state) => state.images;


// WEBPACK FOOTER //
// ./src/App/state/images/selectors.js